import * as React from "react";
import {API_URL} from '../../../settings/local_settings';
import GoogleButton from "react-google-button";
import {AuthUrlLinkBase} from "./AuthUrlLinkBase";
import {APIClient} from "../../../utils/APIClient";
import { withTranslation } from 'react-i18next';


export class GSCLinkComponentClass extends AuthUrlLinkBase {

    redirectToAuthPage() {
        const url = this._getAuthURL();
        new APIClient(url).call('GET')
            .then((data) => {
                window.location = data.auth_url
            }).catch((error) => {
            alert(error)
        })
    }

    _getAuthURL(){
        return API_URL + 'get_auth_url/gsc/';
    }

    _getDeleteUrl(){
        return API_URL + 'agency/gsc-connection/delete/';
    }

    renderConnectionButton() {
        return (<GoogleButton onClick={this.redirectToAuthPage} type="light" />);
    }

    renderDisconnectButton() {
        const { t } = this.props;
        return <button className="btn" onClick={this.deleteAgencyConnection}>{t('gsc_link.disconnect_from_gsc', 'Desconectar de Google Search Console')}</button>
    }
}

export const GSCLinkComponent = withTranslation()(GSCLinkComponentClass);
export default GSCLinkComponent;
